module.exports = __webpack_public_path__ + "img/horizontal_4_4_r_pp12_3016.9ebcbb17.png";